const lowerBoundOf = (value)=>value.gte != null ? "≥".concat(value.gte) : value.gt != null ? ">".concat(value.gt) : null;
const upperBoundOf = (value)=>value.lte != null ? "≤".concat(value.lte) : value.lt != null ? "<".concat(value.lt) : null;
export const summarizeDecimalRange = (value)=>{
    if (value.gte != null && value.lte != null) return "".concat(value.gte, "–").concat(value.lte);
    const lower = lowerBoundOf(value);
    const upper = upperBoundOf(value);
    if (lower != null && upper != null) return "".concat(lower, " ").concat(upper);
    if (lower != null) return lower;
    if (upper != null) return upper;
    if (value.eq != null) return "=".concat(value.eq);
    if (value.neq != null) return "≠".concat(value.neq);
    return '';
};
